<template>
  <v-container>
    <!--//@*/*
    //    *RPD Nbirs test App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- s3 Q 1 -->
    <v-row id="s3q1" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 1</v-card-title>
          <v-card-subtitle class="pb-0">
            Below are listed the IBRS codes and Data values captured on the 1st
            screen of a Tiburon police report. From the list provided, write
            down the number corresponding to the descriptions next to the
            description. Some numbers may be used more than once, and some may
            not be used at all. For example: Next to “IBRS Code” write the
            number “7”, replacing "0", as that is where the IBRS code auto
            populates.
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <img
              class=""
              src="../../../wwwroot/question_images/tiburon_screen_750.png"
            />
            <!-- <img
              class=""
              src="../../../wwwroot/question_images/tiburon_screen_306.png"
            /> -->
            <a href="JavaScript:void(0);" @click="show_dialog(1)">
              Click to zoom
            </a>
          </v-card-subtitle>
          <!-- TIB question flex -->
          <!-- noWordWrap -->
          <v-row justify="center" class="ans-list">
            <!-- Column 1 -->
            <v-col cols="12">
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex pr-1 pl-0 s3q1-label1" inset
                  >Cargo Theft</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  class="s3q1-width inputMargin centered-input"
                  @focus="$event.target.select()"
                  v-model="local_tibQuestions.cargo"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex pr-1 pl-0 s3q1-label1" inset
                  >Hate Crime</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  class="s3q1-width centered-input"
                  @focus="$event.target.select()"
                  v-model="local_tibQuestions.hate"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex pr-1 pl-0 s3q1-label1" inset
                  >Domestic Violence</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  v-model="local_tibQuestions.domViolence"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                  class="s3q1-width centered-input"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex pr-1 pl-0 s3q1-label1" inset
                  >NOC Description</v-subheader
                >
                <!-- align-end justify-end -->
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  v-model="local_tibQuestions.nocDesc"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                  class="s3q1-width centered-input"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex pr-1 pl-0 s3q1-label1" inset
                  >NOC Code</v-subheader
                >
                <!-- align-end justify-end  -->
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  v-model="local_tibQuestions.nocCode"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                  class="s3q1-width centered-input"
                >
                </v-text-field>
              </v-row>
              <v-row
                class="s3q1-row-height qwraps-parent hide-on-medium hide-on-large"
              >
                <v-subheader class="d-flex pr-1 pl-0 qwraps-child1" inset
                  >Was force used in the commision of the crime</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width qwraps-child2 centered-input"
                  v-model="local_tibQuestions.force"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height hide-on-small">
                <v-subheader class="d-flex pr-1 pl-0 mt-2" inset
                  >Was force used in the commision of the crime</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.force"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex s3q1-label1 pr-1 pl-0" inset
                  >Location Type of Crime</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.location"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex s3q1-label1 pr-1 pl-0" inset
                  >Crime attempted or completed.</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.attempted"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex s3q1-label1 pr-1 pl-0" inset
                  >Number of premises entered.</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.premises"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex s3q1-label1 pr-1 pl-0" inset
                  >Was this a gang crime?</v-subheader
                >
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.gang"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row
                class="s3q1-row-height qwraps-parent hide-on-medium hide-on-large"
              >
                <v-subheader class="d-flex pr-1 pl-0 qwraps-child1" inset>
                  Involvement type (buying, selling, concealing, etc.)
                </v-subheader>
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width qwraps-child2 centered-input"
                  v-model="local_tibQuestions.involvement"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height hide-on-small">
                <v-subheader class="d-flex pr-1 pl-0 mt-2" inset>
                  Involvement type (buying, selling, concealing, etc.)
                </v-subheader>
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.involvement"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>

              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex s3q1-label1 pr-1 pl-0" inset>
                  IBRS code
                </v-subheader>
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.ibrsCode"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>

              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex s3q1-label1 pr-1 pl-0" inset>
                  Weapon Type
                </v-subheader>
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.weaponType"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>

              <v-row class="s3q1-row-height qparent">
                <v-subheader class="d-flex s3q1-label1 pr-1 pl-0" inset>
                  Sequence number of the offense
                </v-subheader>
                <v-text-field
                  hide-spin-buttons
                  class="s3q1-width centered-input"
                  @focus="$event.target.select()"
                  v-model="local_tibQuestions.sequence"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>

              <v-row
                class="s3q1-row-height qwraps-parent2 hide-on-medium hide-on-large"
              >
                <v-subheader class="d-flex pr-1 pl-0 qwraps-child1" inset>
                  Was a Computer, Drugs or Alcohol used in the commission of the
                  crime
                </v-subheader>
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width qwraps-child2 centered-input"
                  v-model="local_tibQuestions.commission"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
              <v-row class="s3q1-row-height hide-on-small">
                <v-subheader class="d-flex pr-1 pl-0 mt-2" inset>
                  Was a Computer, Drugs or Alcohol used in the commission of the
                  crime
                </v-subheader>
                <v-text-field
                  hide-spin-buttons
                  @focus="$event.target.select()"
                  class="s3q1-width centered-input"
                  v-model="local_tibQuestions.commission"
                  label=""
                  required
                  placeholder=""
                  type="number"
                  min="1"
                  max="2"
                >
                </v-text-field>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- v-dialog -->

    <v-dialog v-model="bShow_dialog" width="790">
      <v-card>
        <!-- text-h5 -->
        <v-card-title class="grey lighten-2 text-no-wrap">
          Manual Page {{ current_page.pg }}
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="bShow_dialog = false"> Close </v-btn>
        </v-card-actions>
        <!-- style="width: 92%" -->
        <!-- <v-card-text>
          <img :src="current_page.src" :alt="'Manual ' + current_page" />
        </v-card-text> -->
        <v-card-text>
          <div v-html="current_page_html_page"></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="bShow_dialog = false"> Close </v-btn>
        </v-card-actions>

        <v-divider></v-divider>
      </v-card>
    </v-dialog>

    <!--s3 Q2-->
    <v-row id="s3q2" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 2</v-card-title>
          <v-card-subtitle class="pb-0">
            For NIBRS, the FBI UCR Program defines an
            <em>incident</em> as:
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <!--<a href="#">
                    <img src="../images/question_images/s3q2.png" /> See page 5 of
                      the 2021.1 NIBRS User Manual</a
                    > -->
            <a href="JavaScript:void(0);" @click="show_dialog(5)">
              See page 5 of the 2021.1 NIBRS User Manual
            </a>
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q2" class="ml-8 mt-0">
            <v-radio
              label="any report LE takes, regardless as to whether or not a NIBRS reportable crime has occurred."
              value="s3q2-1"
            ></v-radio>
            <v-radio
              label="any offense committed by the same offender, regardless of the time and place the offense occurred."
              value="s3q2-2"
            >
            </v-radio>
            <v-radio
              label="one or more offenses committed by the same offender, or group of offenders acting in concert, at the same time and place."
              value="s3q2-3"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q3  -->
    <v-row id="s3q3" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 3</v-card-title>
          <v-card-subtitle class="pb-0">
            The only traffic offenses NIBRS collects data on is:
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <!-- <a href="#"
                      >See page 8 of the 2021.1 NIBRS User Manual
                    </a> -->
            <a href="JavaScript:void(0);" @click="show_dialog(8)">
              See page 8 of the 2021.1 NIBRS User Manual
            </a>
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q3" class="ml-8 mt-0">
            <v-radio label="Speeding" value="s3q3-1"></v-radio>
            <v-radio
              label="Refusing to yield to a pedestrian or bicyclist"
              value="s3q3-2"
            >
            </v-radio>
            <v-radio
              label="Driving Under the Influence, Hit and Run (of a person) and Vehicular Manslaughter"
              value="s3q3-3"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q 4 -->
    <v-row id="s3q4" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 4</v-card-title>
          <v-card-subtitle class="pb-0">
            Each NIBRS Offense belongs in one of three categories:
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <a href="JavaScript:void(0);" @click="show_dialog(9)">
              See page 9 of the 2021.1 NIBRS User Manual
            </a>
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q4" class="ml-8 mt-0">
            <v-radio
              label="Crimes against Persons, Crimes Against Property, Crimes against Society"
              value="s3q4-1"
            ></v-radio>
            <v-radio
              label="Sexual Assault, Aggravated Assault, Robbery"
              value="s3q4-2"
            >
            </v-radio>
            <v-radio
              label="Attempted Crimes, Completed Crimes, Arrest Warrants"
              value="s3q4-3"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q5  -->
    <v-row id="s3q5" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 5</v-card-title>
          <v-card-subtitle class="pb-0">
            There are ___ Group A offenses and ___ Group B Offense
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <a href="JavaScript:void(0);" @click="show_dialog(9)">
              See page 9 of the 2021.1 NIBRS User Manual
            </a>
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q5" class="ml-8 mt-0">
            <v-radio label="60 and 15" value="s3q5-1"></v-radio>
            <v-radio label="50 and 12" value="s3q5-2"> </v-radio>
            <v-radio label="71 and 10" value="s3q5-3"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q6  -->
    <v-row id="s3q6" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 6</v-card-title>
          <v-card-subtitle class="pb-0">
            The purpose of the FBI UCR Program is to provide a
            _____________________ transcending the varying local and state laws.
            Therefore, the Program _____________ intend for LEAs to use NIBRS
            offense definitions for charging persons with crimes.
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <a href="JavaScript:void(0);" @click="show_dialog(15)"
              >See page 15 of the 2021.1 NIBRS User Manual</a
            >
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q6" class="ml-8 mt-0">
            <v-radio
              label="national criminal definition, / did"
              value="s3q6-1"
            ></v-radio>
            <v-radio label="Federal requirement / did not" value="s3q6-2">
            </v-radio>
            <v-radio label="common language / did not" value="s3q6-3">
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q7  -->
    <v-row id="s3q7" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 7</v-card-title>
          <v-card-subtitle class="pb-0">
            If a state statute for an offense includes additional offenses not
            fitting the NIBRS offense definition, the LEA should report the
            nonconforming offenses according to its ___________ offense
            classifications.
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <a href="JavaScript:void(0);" @click="show_dialog(15)">
              See page 15 of the 2021.1 NIBRS User Manual
            </a>
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q7" class="ml-8 mt-0">
            <v-radio label="NIBRS" value="s3q7-1"></v-radio>
            <v-radio label="State’s" value="s3q7-2"> </v-radio>
            <v-radio label="Local Municipal Code’s" value="s3q7-3"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q8  -->
    <v-row id="s3q8" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 8</v-card-title>
          <v-card-subtitle class="pb-0">
            An assault where a person is threatened with a bat needs to be
            reported as attempted.
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <a href="JavaScript:void(0);" @click="show_dialog(89)"
              >See pages 8 & 9 of the 2021.1 NIBRS User Manual</a
            >
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q8" class="ml-8 mt-0">
            <v-radio label="True" value="s3q8-1"></v-radio>
            <v-radio label="False" value="s3q8-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q9  -->
    <v-row id="s3q9" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 9</v-card-title>
          <v-card-subtitle class="pb-0">
            Prostitution is considered to be a crime against a person.
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <a href="JavaScript:void(0);" @click="show_dialog(89)"
              >See pages 8 & 9 of the 2021.1 NIBRS User Manual</a
            >
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q9" class="ml-8 mt-0">
            <v-radio label="True" value="s3q9-1"></v-radio>
            <v-radio label="False" value="s3q9-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q10  -->
    <v-row id="s3q10" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 10</v-card-title>
          <v-card-subtitle class="pb-0">
            Driving Under the Influence is a Society Crime.
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <a href="JavaScript:void(0);" @click="show_dialog(89)"
              >See pages 8 & 9 of the 2021.1 NIBRS User Manual</a
            >
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q10" class="ml-8 mt-0">
            <v-radio label="True" value="s3q10-1"></v-radio>
            <v-radio label="False" value="s3q10-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- s3 Q 11 -->
    <v-row id="s3q11" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 11</v-card-title>
          <v-card-subtitle class="pb-0">
            A Hit and Run resulting in damage to a fence is reported as a Crime
            against Property
          </v-card-subtitle>
          <v-card-subtitle class="pt-0 reference">
            <a href="JavaScript:void(0);" @click="show_dialog(89)"
              >See pages 8 & 9 of the 2021.1 NIBRS User Manual</a
            >
          </v-card-subtitle>
          <v-radio-group v-model="local_s3answers.s3q11" class="ml-8 mt-0">
            <v-radio
              @click.prevent="ScoreButtonOn"
              label="True"
              value="s3q11-1"
            ></v-radio>
            <v-radio
              @click.prevent="ScoreButtonOn"
              label="False"
              value="s3q11-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100%;
    max-width: 768px;
    height: auto;
    padding-top: 65px;
    margin: auto;
  }

  #home-container .v-card__subtitle {
    color: #5c5c5c;
  }

  #home-container a {
    color: #1565c0;
  }

  #home-container a.temp-2-nav {
    color: aliceblue;
  }

  .fixWidth {
    width: 100%;
  }

  .rad1 {
    background-color: white;
    height: 250px;
    width: 80%;
  }

  .alice {
    color: aliceblue;
  }

  .v-card__subtitle.reference {
    color: blue;
  }

  #sworn_test_section1 .top-card,
  #sworn_test_section2 .top-card,
  #supp .top-card {
    background-color: #324e96;
  }

  #sworn_test_section2,
  #supp {
    width: 104%;
  }

  #s3q1 {
    height: auto;
  }

  .ans-list {
    padding-bottom: 16px;
  }

  #s3q1 .reference img {
    width: 100%;
    height: auto;
  }

  #s3q1 .v-dialog .v-card__text img {
    width: 100% !important;
  }

  #s3q1 .v-dialog > .v-card > .v-card__text {
    padding: 0 5px;
  }

  .s3q1-width {
    width: 20%;
    max-width: 41px;
  }
  .s3q1-row-height {
    height: 36px;
    justify-content: space-between;
    width: 100%;
  }

  #s3q1 .v-subheader--inset {
    margin-left: 22px;
  }

  .s3q1-label1 {
    width: 80%;
  }

  .s3q1-label2 {
    width: 20%;
  }

  #s3q1 .qparent {
    width: 100%;
    height: 36px;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    flex-wrap: wrap;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
  }

  #s3q1 .qwraps-parent {
    width: 100%;
    height: 50px;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    flex-wrap: wrap;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
  }

  #s3q1 .qwraps-parent2 {
    width: 100%;
    height: 105px;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    flex-wrap: wrap;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
    margin-top: 5px;
  }

  .qwraps-parent .qwraps-child1 {
    width: 80%;
    margin-top: 16px;
  }

  .qwraps-parent .qwraps-child2 {
    width: 20%;
  }

  .qwraps-parent2 .qwraps-child1 {
    width: 80%;
    /* margin-top: 16px; */
  }

  .qwraps-parent2 .qwraps-child2 {
    width: 20%;
  }

  .centered-input >>> input {
    text-align: center;
  }

  .noWordWrap {
    white-space: nowrap;
  }

  .fixWidth_name {
    width: 99%;
  }

  .fixWidth_header {
    width: 100%;
  }

  .v-dialog img {
    width: 95%;
  }

  .v-dialog .v-card__text {
    padding: 0 5px;
  }

  .v-dialog .v-card .v-card__title {
    font-size: 5vw;
  }
}

@media (min-width: 359px) {
  #s3q1 .s3q1-label1 {
    width: 75%;
  }

  .qwraps-parent .qwraps-child1,
  .qwraps-parent2 .qwraps-child1 {
    width: 75%;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }

  /*   .s3q1-row-height {
    height: 36px;
    justify-content: space-between;
    width: 94%;
  } */

  .ans-list {
    padding-bottom: 60px;
    width: 80%;
    margin: auto;
  }

  .v-dialog img {
    width: 100%;
  }

  #s3q1 .s3q1-label1 {
    width: 80%;
  }

  .qwraps-parent .qwraps-child1,
  .qwraps-parent2 .qwraps-child1 {
    width: 80%;
  }
}

@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .fixWidth {
    width: 80%;
  }

  .fixWidth_name {
    width: 80%;
  }

  .v-dialog .v-card .v-card__title {
    font-size: 4vw;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }

  .fixWidth {
    width: 80%;
  }

  .fixWidth_name {
    width: 80%;
  }

  .v-dialog .v-card .v-card__title {
    font-size: 2vw;
  }

  .ans-list {
    padding-bottom: 60px;
    width: 100%;
    margin: unset;
  }

  .s3q1-row-height {
    width: 100%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "section3",
  mixins: [bus_common],
  props: ["session", "s3answers", "tibQuestions"],
  data() {
    return {
      bReadyToUpdate: false,
      local_tibQuestions: {},
      local_s3answers: {},
      current_page: {},
      bShow_dialog: false,
      search: "",
      manpages: [
        {
          id: 1,
          pg: "image",
          html: `<style>
  @media (min-width: 0px) {
    .tibscreen img {
      width: 306px;
    }
  }

  /* 768 media q */
  @media (min-width: 768px) {
    .tibscreen img {
      width: 100%;
    }
  }
</style>
<div class="c17 tibscreen">
  <img src="../question_images/tiburon_screen_750.png" alt="tib screen" />
</div>`,
        },
        {
          id: 5,
          pg: "5",
          html: `<style>
  .c8 {
    color: #000000;
    font-weight: 400;
    opacity: 1;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Calibri";
    font-style: normal;
  }
  .c17 {
    margin-left: 6.6pt;
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1;
    text-align: left;
  }

  .c36 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }

  .c77 {
    color: #4f81bd;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 13pt;
    font-family: "Cambria";
    font-style: normal;
  }
  .c42,
  .c299,
  .c75,
  .c63 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }
</style>

<p class="c17">
  <span class="c77">2.1 Definition of an Incident</span>
</p>
<p class="c851">
  <span class="c8">For NIBRS, the FBI UCR Program defines an </span
  ><span class="c36">incident </span
  ><span class="c8"
    >as one or more offenses committed by the same offender, or group of
    offenders acting in concert, at the same time and place.
  </span>
</p>
<p class="c719">
  <span class="c42">The Concept of Acting in Concert </span>
</p>
<p class="c275">
  <span class="c36">Acting in Concert </span
  ><span class="c8"
    >requires all the offenders to actually commit or assist in the commission
    of all of the crimes in an incident. The offenders must be aware of, and
    consent to, the commission of all the offenses; or even if nonconsenting,
    their actions assist in the commission of all the offenses. See </span
  ><span class="c299 c75">Example 1, Acting in Concert</span
  ><span class="c8"
    >. This is important because NIBRS considers all of the offenders in an
    incident to have committed all of the offenses in an incident. The arrest of
    any offender will clear all of the offenses in the incident. If one or more
    of the offenders did not act in concert, then the LEA should report more
    than one incident. See Examples </span
  ><span class="c299 c75">2 </span><span class="c8">and </span
  ><span class="c299 c75">3</span><span class="c8">, Acting in Concert. </span>
</p>
<p class="c673">
  <span class="c42">The Concept of Same Time and Place </span>
</p>
<p class="c396">
  <span class="c8">The fundamental concept of </span
  ><span class="c36">Same Time and Place </span
  ><span class="c8"
    >presupposes that if the same person or group of persons committed more than
    one crime and the time and space intervals separating them were
    insignificant, all the crimes make up a single incident. Normally, the
    offenses must have occurred during an unbroken time period and at the same
    or adjoining locations. However, incidents can also be comprised of offenses
    which, by their nature, involve continuing criminal activity by the same
    offenders at different times and places if, LE deems the activity to
    constitute a single criminal transaction. See </span
  ><span class="c299 c75">Example 4, Same Time and Place.</span
  ><span class="c75 c417"></span>
</p>
<p class="c334">
  <span class="c8"
    >In Summary Reporting System (SRS), LEAs used the concept of Same Time and
    Place to determine whether they should apply the Hierarchy Rule to a group
    of crimes. The agency reported only the crime highest in the hierarchy.
    Though NIBRS does not follow the Hierarchy Rule, LEAs must still apply the
    concept of Same Time and Place to determine whether a group of crimes
    constitutes a single incident. This is crucially important since the
    application of the concept determines whether LEAs should report the crimes
    as individual incidents or as a single incident comprised of multiple
    offenses.
  </span>
</p>
<p class="c510">
  <span class="c42"
    >Examples of Acting in Concert and Same Time and Place
  </span>
</p>
<p class="c628">
  <span class="c8"
    >It is impossible to provide instructions to cover all situations. However,
    some examples are provided below.
  </span>
</p>

<p class="c38"><span class="c63">Example 1, Acting in Concert </span></p>
<p class="c117">
  <span class="c8"
    >During a robbery in a bar, one offender began to rape a victim. The other
    offender told the rapist to stop and only rob the victim. In this example,
    there was only one incident with two offenses (Robbery and Rape). Although
    the other robber did not consent to the Rape, by displaying a gun he
    prevented someone from coming to the victim&rsquo;s assistance and thereby
    assisted in the commission of the crime. The LEA should report one incident
    with two offenses. Both offenders are connected to the victim through the
    offense of Robbery and Rape.
  </span>
</p>
<p class="c813"><span class="c63">Example 2, Acting in Concert </span></p>
<p class="c169">
  <span class="c8"
    >A domestic argument escalated from a shouting match between a husband and
    wife to an aggravated assault during which the husband began beating his
    wife. The wife, in her own defense, shot and killed her husband. The
    responding officer submitted one incident report. The LEA should have
    reported this information via NIBRS as two separate incidents because the
    husband could not have been acting in concert with the wife in his own
    killing. The LEA would submit one incident involving the aggravated assault
    perpetrated by the husband and a second incident involving the killing. This
    would allow the maintenance of the original incident number for record
    keeping purposes at the local level and simultaneously satisfy reporting
    requirements for NIBRS.
  </span>
</p>
<p class="c229"><span class="c63">Example 3, Acting in Concert </span></p>
<p class="c475">
  <span class="c8"
    >Two offenders robbed a bar, forcing the bartender to surrender money from
    the cash register at gunpoint. The robbers also took money and jewelry from
    three customers. One of the robbers, in searching for more customers to rob,
    found a female customer in the rest room and raped her there without the
    knowledge of the other offender. When the rapist returned, both robbers
    left. In this example, there were two incidents: one involving Robbery and
    the other involving Rape, because the offenders were not acting in concert
    in both offenses. The LEA should report two incidents, each with one
    offense.
  </span>
</p>
<p class="c229"><span class="c63">Example 4, Same Time and Place </span></p>
<p class="c798">
  <span class="c8"
    >Over a period of 18 months, a computer programmer working for a bank
    manipulated the bank&rsquo;s computer and systematically embezzled $70,000.
    The continuing criminal activity </span
  ><span class="c36">against the same victim </span
  ><span class="c8"
    >constituted a single incident involving the crime of Embezzlement. </span
  ><span class="c75"><br /><br /></span
  ><span class="c336">04/15/2021 2021.1 NIBRS User Manual 5</span>
</p>
`,
        },
        {
          id: 8,
          pg: "8",
          html: `<style>
  .c8 {
    color: #000000;
    font-weight: 400;
    opacity: 1;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Calibri";
    font-style: normal;
  }
  .c17 {
    margin-left: 6.6pt;
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1;
    text-align: left;
  }

  .c36 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }

  .c77 {
    color: #4f81bd;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 13pt;
    font-family: "Cambria";
    font-style: normal;
  }
  .c42,
  .c299,
  .c75,
  .c63,
  .c22 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }
</style>
<p class="c161">
  <span class="c42"
    >Additional Information Regarding Classifying Offenses
  </span>
</p>
<p class="c136">
  <span class="c8"
    >The UCR Program does not collect information on traffic offenses (e.g.,
    parking and moving violations) except for Driving Under the Influence, Hit
    and Run (of a person), and Vehicular Manslaughter.
  </span>
</p>
<p class="c642">
  <span class="c8"
    >Unless it is a component of a Group A offense (e.g., Human Trafficking)
    when an offense includes one of the Offenses of General Applicability (i.e.,
    words, phrases, or a similar variation thereof), LEAs should report the
    offense as the Group B offense 90Z&mdash;All Other Offenses if the
    substantive offense is a Group A offense. If it involves a Group B offense,
    LEAs should report the offense in the appropriate Group B category. The
    Offenses of General Applicability are Accessory Before/After the Fact,
    Aiding/Abetting, Conspiracy to Commit, Enticement, Facilitation of,
    Solicitation to Commit, Threat to Commit.
  </span>
</p>
<p class="c123">
  <span class="c8"
    >LEAs should report attempted crimes the same as the substantive offense,
    with the data value A = Attempted in Data Element 7 (Offense
    Attempted/Completed). Agencies should report attempted murders as Aggravated
    Assaults, and </span
  ><span class="c36">all </span
  ><span class="c8">assaults should be reported as C = Completed. (</span
  ><span class="c22">Data elements </span
  ><span class="c8"
    >are data fields within each segment of the Group A Incident Report and in
    the Group B Arrest Report to describe the details of each component of a
    crime; a </span
  ><span class="c22">data value </span
  ><span class="c8"
    >is a specific characteristic or type of field being reported that has an
    assigned code, e.g., M = Male or F = Female).
  </span>
</p>
<p class="c229"><span class="c22">Example 1 </span></p>
<p class="c674">
  <span class="c8"
    >An LEA arrested three members of a motorcycle gang for conspiracy to commit
    Murder. The LEA should submit three Group B Arrest Reports with the UCR
    Arrest Offense Code entered as 90Z = All Other Offenses.
  </span>
</p>
<p class="c276"><span class="c22">Example 2 </span></p>
<p class="c582">
  <span class="c8"
    >An LEA arrested five liquor store owners for conspiring to avoid paying
    local liquor taxes. The LEA should submit five Group B Arrest Reports with
    the UCR Arrest Offense Code entered as 90G = Liquor Law Violations.
  </span>
</p>
<p class="c229"><span class="c22">Example 3 </span></p>
<p class="c53">
  <span class="c8"
    >A witness observed and scared away two unknown teenagers who were trying to
    set fire to an abandoned building. The LEA should submit a Group A Incident
    Report that indicated the UCR Offense Code as 200 = Arson and the offense
    was Attempted.</span
  ><span class="c75"><br /><br /></span
  ><span class="c24">04/15/2021 2021.1 NIBRS User Manual 8 </span>
</p>
`,
        },
        {
          id: 9,
          pg: "9",
          html: `<style>
  .c8 {
    color: #000000;
    font-weight: 400;
    opacity: 1;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Calibri";
    font-style: normal;
  }
  .c17 {
    margin-left: 6.6pt;
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1;
    text-align: left;
  }

  .c36 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }

  .c77,
  .c132 {
    color: #4f81bd;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 13pt;
    font-family: "Cambria";
    font-style: normal;
  }
  .c42,
  .c299,
  .c75,
  .c63 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }
</style>
<p class="c17">
  <span class="c42"
    >Offense Categories &ndash; Crimes Against Persons, Property, and Society
  </span>
</p>
<p class="c240">
  <span class="c8"
    >Each NIBRS offense belongs in one of three categories: Crimes Against
    Persons, Crimes Against Property, and Crimes Against Society. Crimes Against
    Persons, e.g., Murder, Rape, and Assault, are those offenses whose victims
    are always individuals. The object of Crimes Against Property,
  </span>
</p>
<p class="c318">
  <span class="c8"
    >e.g., Robbery, Bribery, and Burglary, is to obtain money, property, or some
    other benefit. Crimes Against Society, e.g., Animal Cruelty, Drug
    Violations, Gambling, and Prostitution, represent society&rsquo;s
    prohibition against engaging in certain types of activity.
  </span>
</p>
<p class="c496">
  <span class="c8"
    >For counting purposes, agencies should count one offense for each victim of
    a Crime Against Person, one offense for each distinct operation of a Crime
    Against Property (except for Motor Vehicle Theft, where one offense is
    counted for each stolen vehicle), and one offense for each Crime Against
    Society.
  </span>
</p>
<p class="c602">
  <span class="c8"
    >The listings of the Group A and Group B offenses appearing in this section
    indicate whether the offenses are Crimes Against Persons, Property, or
    Society.
  </span>
</p>
<p class="c673">
  <span class="c42">The Use of Offense Codes in NIBRS </span>
</p>
<p class="c785">
  <span class="c8"
    >In NIBRS, there are 81 three-digit UCR offense codes; one for each of the
    71 Group A and 10 Group B offenses. The three-digit data values are used to
    identify the Group A and Group B offenses in an incident to submit NIBRS
    Group A Incident Reports and Group B Arrest Reports.
  </span>
</p>
<p class="c202"><span class="c132">Group A Offense Codes </span></p>
<p class="c170">
  <span class="c8"
    >There are 28 Group A crime categories made up of 71 Group A offenses;
    therefore, there are 71 Group A Offense Codes. The Group A Offense Codes,
    while unique to NIBRS, were generally derived from the four-digit NCIC
    Uniform Offense Classification Codes to facilitate interrelating offense
    data between the NCIC and the FBI UCR Program. NIBRS correlates these data
    using the first two characters from the NCIC codes of certain offenses as
    the same first two characters of the UCR Offense Codes for respective
    offenses. The third character of the NIBRS Offense Code is designated as
    either a zero (0) or an alphabetic character (A, B, C, etc.) to reference a
    subcategory of the crime category. For example, the NCIC code for Simple
    Assault is 1313, and the NIBRS Offense Code is 13B, e.g., 13B = Simple
    Assault.
  </span>
</p>
<p class="c100">
  <span class="c8"
    >Exceptions to the coding convention of Group A offenses are:
  </span>
</p>
<p class="c297">
  <span class="c8"
    >1. The NCIC Offense Code for Statutory Rape is 1116, but the NIBRS Offense
    Code is 36B = Statutory Rape.
  </span>
</p>
<p class="c833">
  <span class="c8"
    >2. The NCIC Offense Code for Fondling (of child) is 3601, but the NIBRS
    Offense Code is 11D = Fondling.
  </span>
</p>
<p class="c494">
  <span class="c8"
    >3. The NCIC Offense Code and NIBRS Offense Code for Espionage* is 103,
    Treason* is 101. 4. The NIBRS Offense Code for Violation of National Firearm
    Act of 1934* is 521; there is no NCIC Offense Code.</span
  >
</p>
<p class="c101">
  <span class="c24">04/15/2021 2021.1 NIBRS User Manual 9 </span>
</p>
<!-- jm index end page 9 -->
`,
        },
        {
          id: 15,
          pg: "15",
          html: `<style>
  .c8 {
    color: #000000;
    font-weight: 400;
    opacity: 1;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Calibri";
    font-style: normal;
  }
  .c17 {
    margin-left: 6.6pt;
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1;
    text-align: left;
  }

  .c36 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }

  .c77 {
    color: #4f81bd;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 13pt;
    font-family: "Cambria";
    font-style: normal;
  }
  .c42,
  .c299,
  .c75,
  .c63 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }
</style>
<p class="c17">
  <span class="c77">2.4 Offense Definitions </span>
</p>
<p class="c351">
  <span class="c42">Source of Offense Definitions </span>
</p>
<p class="c448">
  <span class="c8"
    >The use of standardized definitions in NIBRS is essential to the
    maintenance of uniform and consistent data. This practice ensures the FBI
    UCR Program considers and appropriately counts all criminal offenses of law,
    regardless of their different titles under state and local law or United
    States titles and statutes.
  </span>
</p>
<p class="c801">
  <span class="c8"
    >The purpose of the FBI UCR Program is to provide a common language
    transcending the varying local and state laws. Therefore, the Program did
    not intend for LEAs to use NIBRS offense definitions for charging persons
    with crimes. Instead, LEAs should use the definitions to translate crime
    into the common UCR language used throughout the United States. Though state
    statutes specifically define crimes so persons facing prosecution will know
    the exact charges placed against them, the definitions used in NIBRS must be
    generic to not exclude varying state statutes relating to the same type of
    crime.
  </span>
</p>
<p class="c176">
  <span class="c8"
    >The Program based NIBRS offense definitions on the common-law definitions
    found in </span
  ><span class="c36">Black&rsquo;s Law Dictionary</span
  ><span class="c8"
    >, as well as those used in the NCIC 2000 Uniform Offense Classifications.
    Due to most states basing their statutes on the common-law definitions, even
    though they may vary as to specifics, these definitions should fit into the
    corresponding NIBRS offense classifications.
  </span>
</p>
<p class="c614"><span class="c42">State Offenses </span></p>
<p class="c782">
  <span class="c8"
    >If a state statute for an offense includes additional offenses not fitting
    the NIBRS offense definition, the LEA should report the nonconforming
    offenses according to its NIBRS offense classifications. For example, some
    states worded their larceny statutes so broadly as to include the crime of
    Embezzlement. If an offender perpetrates Embezzlement within such a state,
    LE should report the offense via NIBRS as Embezzlement, not Larceny/Theft.
  </span>
</p>
<p class="c506">
  <span class="c8"
    >Certainly, unusual situations will arise in classifying offenses, and this
    manual cannot cover all circumstances. In classifying unusual situations, LE
    should consider the nature of the crime along with the guidelines provided.
    In addition to the Group A and Group B offense definitions and explanations,
    the </span
  ><span class="c299 c75">Offense Lookup Table </span
  ><span class="c8"
    >at the end of this section will also aid in classifying offenses. If LEAs
    have concerns on how to classify an offense they can contact the FBI UCR
    Program Office.</span
  ><span class="c75"><br /><br /></span
  ><span class="c24">04/15/2021 2021.1 NIBRS User Manual 15 </span>
</p>
`,
        },
        {
          id: 89,
          pg: "8 & 9",
          html: `<style>
  .c8 {
    color: #000000;
    font-weight: 400;
    opacity: 1;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Calibri";
    font-style: normal;
  }
  .c17 {
    margin-left: 6.6pt;
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1;
    text-align: left;
  }

  .c36 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }

  .c77,
  .c132 {
    color: #4f81bd;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 13pt;
    font-family: "Cambria";
    font-style: normal;
  }
  .c42,
  .c299,
  .c75,
  .c63,
  .c22 {
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 12pt;
    font-family: "Cambria";
    font-style: italic;
  }
</style>
<p class="c161">
  <span class="c42"
    >Additional Information Regarding Classifying Offenses
  </span>
</p>
<p class="c136">
  <span class="c8"
    >The UCR Program does not collect information on traffic offenses (e.g.,
    parking and moving violations) except for Driving Under the Influence, Hit
    and Run (of a person), and Vehicular Manslaughter.
  </span>
</p>
<p class="c642">
  <span class="c8"
    >Unless it is a component of a Group A offense (e.g., Human Trafficking)
    when an offense includes one of the Offenses of General Applicability (i.e.,
    words, phrases, or a similar variation thereof), LEAs should report the
    offense as the Group B offense 90Z&mdash;All Other Offenses if the
    substantive offense is a Group A offense. If it involves a Group B offense,
    LEAs should report the offense in the appropriate Group B category. The
    Offenses of General Applicability are Accessory Before/After the Fact,
    Aiding/Abetting, Conspiracy to Commit, Enticement, Facilitation of,
    Solicitation to Commit, Threat to Commit.
  </span>
</p>
<p class="c123">
  <span class="c8"
    >LEAs should report attempted crimes the same as the substantive offense,
    with the data value A = Attempted in Data Element 7 (Offense
    Attempted/Completed). Agencies should report attempted murders as Aggravated
    Assaults, and </span
  ><span class="c36">all </span
  ><span class="c8">assaults should be reported as C = Completed. (</span
  ><span class="c22">Data elements </span
  ><span class="c8"
    >are data fields within each segment of the Group A Incident Report and in
    the Group B Arrest Report to describe the details of each component of a
    crime; a </span
  ><span class="c22">data value </span
  ><span class="c8"
    >is a specific characteristic or type of field being reported that has an
    assigned code, e.g., M = Male or F = Female).
  </span>
</p>
<p class="c229"><span class="c22">Example 1 </span></p>
<p class="c674">
  <span class="c8"
    >An LEA arrested three members of a motorcycle gang for conspiracy to commit
    Murder. The LEA should submit three Group B Arrest Reports with the UCR
    Arrest Offense Code entered as 90Z = All Other Offenses.
  </span>
</p>
<p class="c276"><span class="c22">Example 2 </span></p>
<p class="c582">
  <span class="c8"
    >An LEA arrested five liquor store owners for conspiring to avoid paying
    local liquor taxes. The LEA should submit five Group B Arrest Reports with
    the UCR Arrest Offense Code entered as 90G = Liquor Law Violations.
  </span>
</p>
<p class="c229"><span class="c22">Example 3 </span></p>
<p class="c53">
  <span class="c8"
    >A witness observed and scared away two unknown teenagers who were trying to
    set fire to an abandoned building. The LEA should submit a Group A Incident
    Report that indicated the UCR Offense Code as 200 = Arson and the offense
    was Attempted.</span
  ><span class="c75"><br /><br /></span
  ><span class="c24">04/15/2021 2021.1 NIBRS User Manual 8 </span>
</p>
<p class="c17">
  <span class="c42"
    >Offense Categories &ndash; Crimes Against Persons, Property, and Society
  </span>
</p>
<p class="c240">
  <span class="c8"
    >Each NIBRS offense belongs in one of three categories: Crimes Against
    Persons, Crimes Against Property, and Crimes Against Society. Crimes Against
    Persons, e.g., Murder, Rape, and Assault, are those offenses whose victims
    are always individuals. The object of Crimes Against Property,
  </span>
</p>
<p class="c318">
  <span class="c8"
    >e.g., Robbery, Bribery, and Burglary, is to obtain money, property, or some
    other benefit. Crimes Against Society, e.g., Animal Cruelty, Drug
    Violations, Gambling, and Prostitution, represent society&rsquo;s
    prohibition against engaging in certain types of activity.
  </span>
</p>
<p class="c496">
  <span class="c8"
    >For counting purposes, agencies should count one offense for each victim of
    a Crime Against Person, one offense for each distinct operation of a Crime
    Against Property (except for Motor Vehicle Theft, where one offense is
    counted for each stolen vehicle), and one offense for each Crime Against
    Society.
  </span>
</p>
<p class="c602">
  <span class="c8"
    >The listings of the Group A and Group B offenses appearing in this section
    indicate whether the offenses are Crimes Against Persons, Property, or
    Society.
  </span>
</p>
<p class="c673">
  <span class="c42">The Use of Offense Codes in NIBRS </span>
</p>
<p class="c785">
  <span class="c8"
    >In NIBRS, there are 81 three-digit UCR offense codes; one for each of the
    71 Group A and 10 Group B offenses. The three-digit data values are used to
    identify the Group A and Group B offenses in an incident to submit NIBRS
    Group A Incident Reports and Group B Arrest Reports.
  </span>
</p>
<p class="c202"><span class="c132">Group A Offense Codes </span></p>
<p class="c170">
  <span class="c8"
    >There are 28 Group A crime categories made up of 71 Group A offenses;
    therefore, there are 71 Group A Offense Codes. The Group A Offense Codes,
    while unique to NIBRS, were generally derived from the four-digit NCIC
    Uniform Offense Classification Codes to facilitate interrelating offense
    data between the NCIC and the FBI UCR Program. NIBRS correlates these data
    using the first two characters from the NCIC codes of certain offenses as
    the same first two characters of the UCR Offense Codes for respective
    offenses. The third character of the NIBRS Offense Code is designated as
    either a zero (0) or an alphabetic character (A, B, C, etc.) to reference a
    subcategory of the crime category. For example, the NCIC code for Simple
    Assault is 1313, and the NIBRS Offense Code is 13B, e.g., 13B = Simple
    Assault.
  </span>
</p>
<p class="c100">
  <span class="c8"
    >Exceptions to the coding convention of Group A offenses are:
  </span>
</p>
<p class="c297">
  <span class="c8"
    >1. The NCIC Offense Code for Statutory Rape is 1116, but the NIBRS Offense
    Code is 36B = Statutory Rape.
  </span>
</p>
<p class="c833">
  <span class="c8"
    >2. The NCIC Offense Code for Fondling (of child) is 3601, but the NIBRS
    Offense Code is 11D = Fondling.
  </span>
</p>
<p class="c494">
  <span class="c8"
    >3. The NCIC Offense Code and NIBRS Offense Code for Espionage* is 103,
    Treason* is 101. 4. The NIBRS Offense Code for Violation of National Firearm
    Act of 1934* is 521; there is no NCIC Offense Code.</span
  >
</p>
<p class="c101">
  <span class="c24">04/15/2021 2021.1 NIBRS User Manual 9 </span>
</p>
`,
        },
      ],
      myArray: { id1: 100, id2: 200, "tag with spaces": 300 },
      html_pages: [],
      current_page_html_page: "",
      pages: [
        {
          id: 1,
          pg: "0",
          src: "./question_images/s3q1.png",
          html_file: "s3q1.html",
        },
        {
          id: 2,
          pg: "5",
          src: "./question_images/s3q2.png",
          html_file: "s3q2.html",
        },
        {
          id: 3,
          pg: "8",
          src: "./question_images/s3q3.png",
          html_file: "s3q3.html",
        },
        {
          id: 4,
          pg: "9",
          src: "./question_images/s3q4.png",
          html_file: "s3q4.html",
        },
        {
          id: 5,
          pg: "9",
          src: "./question_images/s3q5.png",
          html_file: "s3q5.html",
        },
        {
          id: 6,
          pg: "15",
          src: "./question_images/s3q6.png",
          html_file: "s3q6.html",
        },
        {
          id: 7,
          pg: "15",
          src: "./question_images/s3q7.png",
          html_file: "s3q7.html",
        },
        {
          id: 8,
          pg: "8 & 9",
          src: "./question_images/s3q8.png",
          html_file: "s3q8.html",
        },
        {
          id: 9,
          pg: "8 & 9",
          src: "./question_images/s3q9.png",
          html_file: "s3q9.html",
        },
        {
          id: 10,
          pg: "8 & 9",
          src: "./question_images/s3q10.png",
          html_file: "s3q10.html",
        },
        {
          id: 11,
          pg: "8 & 9",
          src: "./question_images/s3q11.png",
          html_file: "s3q11.html",
        },
        {
          id: 12,
          pg: "Tiburon Screenshot",
          src: "./question_images/tiburon_screen_750.png",
          html_file: "s3q11.html",
        },
      ],
      // sanswer2: {
      //   s3q1: "",
      //   s3q2: "",
      //   s3q3: "",
      //   s3q4: "",
      //   s3q5: "",
      //   s3q6: "",
      //   s3q7: "",
      //   s3q8: "",
      //   s3q9: "",
      //   s3q10: "",
      //   s3q11: "",
      // },
    };
  },
  watch: {
    local_s3answers: {
      deep: true,
      handler() {
        this.update_answers();
      },
    },
    local_tibQuestions: {
      deep: true,
      handler() {
        this.update_answers();
      },
    },
  },
  methods: {
    // ScoreButtonOn() {
    //   this.$emit("ScoreButtonOn");
    // },
    get_manpages() {
      var self = this;
      var pgs = this.pages;
      for (let index = 0; index < pgs.length; index++) {
        const htmlpage = pgs[index].html_file;

        var formIn = {};
        formIn.htmlpage = encodeURI("/html/" + htmlpage);
        formIn.apiname = formIn.htmlpage;

        this.$store
          .dispatch("get_manpages", formIn)
          .then((data) => {
            self.html_pages.push(data);
          })
          .catch((msg) => {
            alert("err something " + msg.msg);
            self.show_loader(false);
            this.swall_it("Error", msg.msg, "error", null, null);
          });
      }
    },
    show_dialog(page) {
      var index = this.manpages.findIndex((item) => item.id === page);
      this.current_page = this.manpages[index];
      this.current_page_html_page = this.manpages[index].html;
      this.bShow_dialog = true;
    },
    update_answers() {
      if (this.bReadyToUpdate) {
        this.$emit(
          "update_answers",
          this.local_s3answers,
          this.local_tibQuestions
        );
      }
    },
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      this.get_manpages();
      this.local_s3answers = this.mno(this.s3answers);
      this.local_tibQuestions = this.mno(this.tibQuestions);
      this.$nextTick(() => {
        this.bReadyToUpdate = true;
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
